import React from 'react';
import styled from 'styled-components';
import { UILanguage } from '~types/types';

interface IControlsProps {
  currentLanguage: UILanguage;
  onLanguageChanged?: (lang) => void;
}

const StyledControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  * {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  div {
    padding: 0 15px;
  }
  a {
    background: #333;
    padding: 0 10px;
    color: rgba(255, 255, 255, 0.45);
    text-decoration: none;
    border-right: 1px solid #404040;
  }
  a:last-child {
    border: none;
  }
  a:hover {
    text-decoration: underline;
  }
  a.active {
    color: rgba(255, 255, 255, 1);
  }
`;

const languages = [UILanguage.Fi, UILanguage.En];

const Languages: React.FC<IControlsProps> = (props: IControlsProps) => {
  const { currentLanguage } = props;

  return (
    <StyledControls>
      <>
        {languages.map(lang => (
          <a
            onClick={() => props.onLanguageChanged(lang)}
            key={lang}
            className={currentLanguage === lang ? 'active' : undefined}
          >
            {lang}
          </a>
        ))}
      </>
    </StyledControls>
  );
};

export default Languages;
